export default __webpack_public_path__ + "static/media/perfil2.ce216426.png";